// Release-time communication only. This is NOT a health endpoint and cannot
// enable/disable delivery. Reconcile against the actual Worker gate before release.
// Set REACT_APP_EMAIL_NOTICE_MODE=none only after the owner verifies delivery is
// enabled; rebuilding is required. See docs/field-notes-release.md.
const emailNoticeMode = process.env.REACT_APP_EMAIL_NOTICE_MODE === 'none' ? 'none' : 'paused';
export const emailDeliveryNotice = Object.freeze({
  mode: emailNoticeMode,
  heading: 'Email delivery is paused during beta.',
  description: 'Checks continue on enabled platforms. Your email preference is saved, but availability emails are not currently being sent.',
  compactDescription: 'Check your watchlist for results.',
});
